import { useState } from 'react';

import FormModal from '../../../Modals/FormModal';

import InputField from '../../../Forms/Input/InputField';

import { ProductPanelItem } from '../../../../types/productpanel/ProductPanelItem';

interface Props {
  isOpen: boolean;

  product: ProductPanelItem;

  quotationId: number;

  onClose: () => void;

  onConfirm: (payload: {
    quotationId: number;

    productId: number;

    quantity: number;

    unitPrice: number;

    discountPercent: number;
  }) => void;
}

const QuotationAddProductModal: React.FC<Props> = ({
  isOpen,

  product,

  quotationId,

  onClose,

  onConfirm,
}) => {
  // =====================================================
  // 🔹 State
  // =====================================================

  const [quantity, setQuantity] = useState('1');

  const [unitPrice, setUnitPrice] = useState(product.price.toString());

  const [discountPercent, setDiscountPercent] = useState('0');

  const discountDisabled = product.appliesDiscount === false;

  // =====================================================
  // 🔹 Handlers
  // =====================================================

  const handleConfirm = () => {
    const parsedQuantity = Number(quantity);

    const parsedPrice = Number(unitPrice);

    const parsedDiscount = Number(discountPercent);

    if (
      !quantity ||
      !unitPrice ||
      parsedQuantity <= 0 ||
      parsedPrice < 0 ||
      parsedDiscount < 0
    ) {
      return;
    }

    onConfirm({
      quotationId,

      productId: product.id,

      quantity: parsedQuantity,

      unitPrice: parsedPrice,

      discountPercent: parsedDiscount,
    });
  };

  // =====================================================
  // 🎨 Render
  // =====================================================

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Agregar producto"
      maxWidth="max-w-md"
    >
      <div className="flex flex-col gap-5">
        {/* ===================================================== */}
        {/* 🔹 Product */}
        {/* ===================================================== */}

        <div>
          <h3
            className="
              text-sm
              font-semibold
              text-black

              dark:text-white
            "
          >
            {product.name}
          </h3>
        </div>

        {/* ===================================================== */}
        {/* 🔹 Inputs */}
        {/* ===================================================== */}

        <div className="grid grid-cols-2 gap-4">
          <InputField
            label="Cantidad"
            name="quantity"
            type="number"
            min={1}
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            iconKey="product"
          />

          <InputField
            label="Precio"
            name="unitPrice"
            type="number"
            step="0.01"
            min={0}
            value={unitPrice}
            onChange={(e) => setUnitPrice(e.target.value)}
            iconKey="dollar"
          />
        </div>

        {/* ===================================================== */}
        {/* 🔹 Discount */}
        {/* ===================================================== */}

        <InputField
          label="Descuento (%)"
          name="discountPercent"
          type="number"
          step="0.01"
          min={0}
          max={100}
          disabled={discountDisabled}
          value={discountDisabled ? '' : (discountPercent === '0' ? '' : discountPercent)}
          onChange={(e) => setDiscountPercent(e.target.value)}
          iconKey="percentage"
        />

        {discountDisabled && (
          <p className="-mt-3 text-xs text-bodydark2">
            Este producto no admite descuentos.
          </p>
        )}

        {/* ===================================================== */}
        {/* 🔹 Actions */}
        {/* ===================================================== */}

        <div className="flex justify-end gap-3">
          {/* 🔹 Cancel */}

          <button
            onClick={onClose}
            className="
              rounded-lg
              border
              border-stroke

              px-4
              py-2

              text-sm
              font-medium

              transition-all

              hover:bg-whiten

              dark:border-strokedark
              dark:hover:bg-meta-4
            "
          >
            Cancelar
          </button>

          {/* 🔹 Confirm */}

          <button
            onClick={handleConfirm}
            className="
              rounded-lg

              bg-primary

              px-4
              py-2

              text-sm
              font-medium
              text-white

              transition-all

              hover:bg-opacity-90
            "
          >
            Agregar
          </button>
        </div>
      </div>
    </FormModal>
  );
};

export default QuotationAddProductModal;
